<div class="content">
  <div class="loc-thumbnail" style="background-color: #eeeeee">
    <img
      class="rounded"
      [src]="
        mapScreenshot
          ? mapScreenshot
          : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
      "
      style="width: 100%; height: inherit"
    />
    <button
      class="btn btn-sm btn-secondary btn-screenshot"
      (click)="setMapScreenshot()"
    >
      {{ "Screenshot" | translate }}
    </button>
  </div>
  <div
    class="card inner-shadow"
    *ngIf="
      isFacility ||
      currLocation?.address ||
      locAdditionalData?.length > 0 ||
      currLocation?.children?.length > 0
    "
  >
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Facility" | translate }}</p>
        <!-- <i class="icon-upload"></i> -->
      </div>
      <div class="description" *ngIf="currLocation?.address">
        <p>{{ "Address" | translate }}</p>
        <p>{{ currLocation?.address }}</p>
      </div>
      <div class="description">
        <p>{{ "Total Assets" | translate }}</p>
        <p>{{ currLocation?.children?.length }}</p>
      </div>
      <div
        class="description additional_data"
        *ngFor="let ad of locAdditionalData"
      >
        <p>{{ ad.key }}</p>
        <p>{{ ad.value }}</p>
      </div>
      <!-- <div class="description">
        <p>{{ 'Person Responsible' | translate }}</p>
        <p>Tanaka Taro</p>
      </div>
      <div class="description">
        <p>{{ 'Contact Details' | translate }}</p>
        <p>080-0000-0000</p>
        <p>tanaka.taro@suntory####.jp</p>
      </div> -->
    </div>
  </div>
  <div class="card inner-shadow" *ngIf="review_module_enabled">
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Endorsement Status" | translate }}</p>
      </div>
      <div class="description">
        <p>
          {{ currLocation?.endorsement_status }}
        </p>
      </div>
    </div>
  </div>

  <div class="card inner-shadow" *ngIf="review_module_enabled">
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Reviewer" | translate }}</p>
        <a *ngIf="!isShowFormReviewer" (click)="toggleForm('formReviewer')">
          <i class="icon-create"></i>
        </a>
      </div>
      <form
        *ngIf="isShowFormReviewer"
        [formGroup]="formReviewers"
        (ngSubmit)="onSubmitForm('formReviewer')"
      >
        <div class="form-row" style="align-items: center">
          <div class="col p-0">
            <div class="form-group" style="margin: 0">
              <input
                formControlName="reviewers"
                type="text"
                class="form-control"
                placeholder="{{ 'Search a user' | translate }}"
                (keyup)="
                  terms$.next({
                    key: $event.target['value'],
                    includeGroup: false
                  })
                "
              />
              <div #autoCompleteR class="auto-complete">
                <ul class="list-group">
                  <li
                    *ngFor="let member of memberSelection; trackById"
                    (click)="selectedReviewer(member)"
                    class="list-group-item"
                  >
                    {{ member?.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div style="padding-top: 0.1em">
            <button
              type="submit"
              class="btn btn-sm btn-circle btn-outline-primary"
              style="margin: 0em 1em"
            >
              <i class="icon-create"></i>
            </button>
            <button
              class="btn btn-sm btn-circle btn-outline-danger"
              (click)="toggleForm('formReviewer', false)"
            >
              <i class="icon-delete"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="list-group">
        <div
          class="no-border list-group-item"
          *ngFor="let members of allReviewer; let i = index; trackById"
        >
          <div class="details">
            <p>{{ members.name }}</p>
          </div>
          <a
            ><i
              class="icon-delete"
              (click)="onDeleteMembers(members.id, i, 'isReviewer')"
            ></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div class="card inner-shadow" *ngIf="review_module_enabled">
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Submitter" | translate }}</p>
        <a *ngIf="!isShowFormSubmitter" (click)="toggleForm('formSubmitter')">
          <i class="icon-create"></i>
        </a>
      </div>
      <form
        *ngIf="isShowFormSubmitter"
        [formGroup]="formSubmitters"
        (ngSubmit)="onSubmitForm('formSubmitter')"
      >
        <div class="form-row" style="align-items: center">
          <div class="col p-0">
            <div class="form-group" style="margin: 0">
              <input
                formControlName="submitters"
                type="text"
                class="form-control"
                placeholder="{{ 'Search a user' | translate }}"
                (keyup)="
                  terms$.next({
                    key: $event.target['value'],
                    includeGroup: false
                  })
                "
              />
              <div #autoCompleteR class="auto-complete">
                <ul class="list-group">
                  <li
                    *ngFor="let member of memberSelection; trackById"
                    (click)="selectedSubmitter(member)"
                    class="list-group-item"
                  >
                    {{ member?.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div style="padding-top: 0.1em">
            <button
              type="submit"
              class="btn btn-sm btn-circle btn-outline-primary"
              style="margin: 0em 1em"
            >
              <i class="icon-create"></i>
            </button>
            <button
              class="btn btn-sm btn-circle btn-outline-danger"
              (click)="toggleForm('formSubmitter', false)"
            >
              <i class="icon-delete"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="list-group">
        <div
          class="no-border list-group-item"
          *ngFor="let members of allSubmitter; let i = index; trackById"
        >
          <div class="details">
            <p>{{ members.name }}</p>
          </div>
          <a
            ><i
              class="icon-delete"
              (click)="onDeleteMembers(members.id, i, 'isSubmitter')"
            ></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card inner-shadow"
    *ngIf="countByAssignedRole && countByAssignedRole.length > 0"
  >
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Registered users" | translate }}</p>
        <!-- <i class="icon-upload"></i> -->
      </div>
      <div
        class="description"
        *ngFor="let role of countByAssignedRole; trackById"
      >
        <p>
          {{
            (role._id === "SuperAdmin" ? "Maintainer" : role._id) | translate
          }}
        </p>
        <p>{{ role.count }}</p>
      </div>
    </div>
  </div>
  <!-- <div class="card inner-shadow">
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ 'Missions' | translate }}</p>
        <i class="icon-upload"></i>
      </div>
      <div class="description">
        <p>{{ 'Total missions to date' | translate }}</p>
        <p>{{ mapLayers.length }}</p>
      </div>
      <div class="description">
        <p>{{ 'Total findings to date' | translate }}</p>
        <p>{{ annotations.length }}</p>
      </div>
    </div>
  </div> -->
  <div class="card inner-shadow">
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Members" | translate }}</p>
        <a *ngIf="!isShowFormMember" (click)="toggleForm('formMember')">
          <i class="icon-create"></i>
        </a>
      </div>
      <form
        *ngIf="isShowFormMember"
        [formGroup]="formMembers"
        (ngSubmit)="onSubmitForm('formMember')"
      >
        <div class="form-row" style="align-items: center">
          <div class="col p-0">
            <div class="form-group" style="margin: 0">
              <input
                formControlName="members"
                type="text"
                class="form-control"
                placeholder="{{ 'Members' | translate }}"
                (keyup)="
                  terms$.next({
                    key: $event.target['value'],
                    includeGroup: true
                  })
                "
              />
              <div #autoComplete class="auto-complete">
                <ul class="list-group">
                  <li
                    *ngFor="let member of memberSelection; trackById"
                    (click)="selectedMember(member)"
                    class="list-group-item"
                  >
                    <span class="badge badge-secondary" *ngIf="member?.isGroup"
                      >Group</span
                    >
                    {{ member?.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="currLocation.children?.length > 0">
            <input
              type="checkbox"
              name="the-checkbox"
              style="margin: 0.5em"
              [checked]="isAllAssets"
              (change)="isAllAssets = !isAllAssets"
            />
            <label for="the-checkbox" style="font-size: 12px">{{
              "Apply all assets" | translate
            }}</label>
          </div>
          <div style="padding-top: 0.1em">
            <button
              type="submit"
              class="btn btn-sm btn-circle btn-outline-primary"
              style="margin: 0em 1em"
            >
              <i class="icon-create"></i>
            </button>
            <button
              class="btn btn-sm btn-circle btn-outline-danger"
              (click)="toggleForm('formMember', false)"
            >
              <i class="icon-delete"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="list-group">
        <div
          class="no-border list-group-item"
          *ngFor="let members of allMembers; let i = index; trackById"
        >
          <div class="details">
            <p>{{ members.name }}</p>
          </div>
          <a
            ><i class="icon-delete" (click)="onDeleteMembers(members.id, i)"></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="permissions && permissions['create:any.annotation']"
    class="card inner-shadow"
  >
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Components" | translate }}</p>
        <a
          data-cy="loc-component-add-enable"
          *ngIf="!isShowFormComp"
          (click)="toggleForm('formComponent')"
        >
          <i class="icon-create"></i>
        </a>
      </div>
      <form
        *ngIf="isShowFormComp"
        [formGroup]="formComponent"
        (ngSubmit)="onSubmitForm('formComponent')"
      >
        <div class="form-row">
          <div class="col p-0">
            <div class="form-group p-0">
              <input
                formControlName="name"
                type="text"
                class="form-control"
                placeholder="{{ 'Name' | translate }}"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <select
                formControlName="component_type"
                class="form-control"
                (click)="onSelect()"
              >
                <option value="" disabled selected>
                  {{ "Type" | translate }}
                </option>
                <option
                  *ngFor="let type of componentTypes; trackById"
                  [value]="type.id"
                >
                  {{ type.name | titlecase }}
                </option>
              </select>
            </div>
          </div>
          <div style="padding-top: 0.1em">
            <button
              data-cy="loc-component-add-confirm"
              type="submit"
              class="btn btn-sm btn-circle btn-outline-primary"
            >
              <i class="icon-create"></i>
            </button>
            <button
              data-cy="loc-component-add-disable"
              class="btn btn-sm btn-circle btn-outline-danger"
              (click)="toggleForm('formComponent', false)"
            >
              <i class="icon-delete"></i>
            </button>
          </div>
        </div>
      </form>
      <div data-cy="location-component-list-group" class="list-group">
        <div
          class="no-border list-group-item"
          *ngFor="let component of components; let i = index; trackById"
        >
          <div class="details">
            <p>{{ component.name }}</p>
          </div>
          <a
            ><i
              class="icon-delete"
              (click)="onDeleteComponent(component.id, i)"
            ></i
          ></a>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="permissions && permissions['create:any.annotation']"
    class="card inner-shadow"
  >
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Map Layer List" | translate }}</p>
        <a
          *ngIf="!isShowFormMap"
          data-cy="map-layer-add-enable"
          (click)="toggleForm('formMapLayer')"
        >
          <i class="icon-create"></i>
        </a>
      </div>
      <form
        *ngIf="isShowFormMap"
        [formGroup]="formMapLayer"
        (ngSubmit)="onSubmitForm('formMapLayer')"
      >
        <div class="form-row">
          <div class="col">
            <div class="form-group p-0">
              <input
                data-cy="map-layer-input-url"
                formControlName="external_url"
                type="text"
                class="form-control"
                placeholder="{{ 'External Url' | translate }}"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group p-0">
              <input
                data-cy="map-layer-input-name"
                formControlName="layer_name"
                type="text"
                class="form-control"
                placeholder="{{ 'Layer Name' | translate }}"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group p-0">
              <input
                data-cy="map-layer-input-date"
                formControlName="layer_date"
                type="date"
                class="form-control"
                placeholder="{{ 'Layer Date' | translate }}"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group p-0">
              <select
                data-cy="map-layer-input-type"
                formControlName="layer_type"
                class="form-control"
              >
                <option value="" disabled selected>
                  {{ "Type" | translate }}
                </option>
                <option
                  *ngFor="
                    let type of [
                      '3d',
                      'ortho',
                      'dsm',
                      'thermal',
                      '3d-mesh',
                      'embed',
                      'geojson',
                      'facade'
                    ];
                    trackById
                  "
                  [value]="type"
                >
                  {{ type | titlecase }}
                </option>
              </select>
            </div>
          </div>
          <div style="padding-top: 0.1em">
            <button
              data-cy="map-layer-add-confirm"
              type="submit"
              class="btn btn-sm btn-circle btn-outline-primary"
            >
              <i class="icon-create"></i>
            </button>
            <button
              data-cy="map-layer-add-disable"
              class="btn btn-sm btn-circle btn-outline-danger"
              (click)="toggleForm('formMapLayer', false)"
            >
              <i class="icon-delete"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="list-group">
        <div
          class="no-border list-group-item"
          *ngFor="let layer of mapLayers; let i = index; trackById"
        >
          <div class="details">
            <p>
              {{
                (layer.layer_name ? layer.layer_name : layer.layer_type)
                  | titlecase
              }}:
              <span class="badge bg-primary text-light">{{
                layer.layer_type | titlecase
              }}</span
              >&nbsp;<a [href]="layer.external_url" target="_blank">{{
                layer.external_url
              }}</a>
            </p>
          </div>
          <a
            ><i
              class="icon-delete"
              [id]="'map-layer-delete-' + layer.layer_name || layer.layer_type"
              (click)="onDeleteLayer(layer.id, i)"
            ></i
          ></a>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="permissions && permissions['create:any.annotation']"
    class="card inner-shadow"
  >
    <div class="card-body">
      <div class="header">
        <p class="title text-left">{{ "Upload Raw Photos" | translate }}</p>
      </div>
      <div class="gallery-container">
        <div>
          <app-file-upload
            (onSelected)="onFileSelected($event)"
          ></app-file-upload>
        </div>
      </div>
      <ng-container *ngIf="ui.files; let files">
        <div class="mb-2">
          <div class="d-flex" style="width: 100%; justify-content: flex-end">
            <form [formGroup]="taskForm">
              <div style="padding-right: 1em">
                <select formControlName="folder" class="form-control">
                  <option value="Raw images">Raw</option>
                  <option value="Raw images/Orthophoto">Ortho Photo</option>
                  <option value="Raw images/Point cloud">Point Cloud</option>
                </select>
              </div>
            </form>
            <div (click)="uploadFiles()" class="btn btn-sm btn-primary">
              {{ "Upload All" | translate }}
            </div>
          </div>
        </div>
        <mat-progress-bar
          *ngIf="progress >= 0"
          mode="determinate"
          value="{{ progress }}"
        ></mat-progress-bar>
        <div class="gallery-container">
          <div class="file-list">
            <ng-container
              *ngFor="let file of files; let idx = index; trackById"
            >
              <div class="file-item p-2">
                <div
                  class="hide-scroll"
                  style="overflow: auto; height: 100%; white-space: nowrap"
                >
                  {{ file.name }}
                </div>
                <div *ngIf="file.uploadStatus == 'queueing'">Queueing...</div>
                <div *ngIf="file.uploadStatus == 'uploading'">Uploading...</div>
                <div *ngIf="file.uploadStatus == 'uploaded'">File uploaded</div>
                <div
                  *ngIf="file.uploadStatus == 'loaded'"
                  class="d-flex"
                  style="flex-flow: column"
                >
                  <div
                    (click)="removeFile('select', idx)"
                    class="btn mb-0 btn-sm btn-warning btn-outline"
                  >
                    {{ "Remove" | translate }}
                  </div>
                  <div
                    (click)="uploadFile(idx)"
                    class="btn mb-0 btn-sm btn-primary"
                  >
                    {{ "Upload" | translate }}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <button
      *ngIf="permissions && permissions['delete:any.location']"
      class="btn btn-sm btn-danger"
      (click)="onDelete()"
    >
      {{ "Delete" | translate }}
    </button>
    <button
      *ngIf="permissions && permissions['update:any.location']"
      class="btn btn-sm btn-secondary"
      (click)="onEdit()"
    >
      {{ "Edit" | translate }}
    </button>
  </div>
</div>
